import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotificationsView from '../components/views/Notifications';
import { withRouter } from '../helpers/withRouter';
import {
  addNotification, checkForNotifications, clearNotifications, closeModal,
  getNotifications, openModal, updateModal,
} from '../redux/actions';
import type {
  NotificationState, Project, Router, SingleModalState, State, User,
} from '../types';

type Props = {
  notifications: NotificationState,
  getNotifications: (page?: number) => Promise<any>,
  addNotification: (target: string, content: string, sendTo: string|Array<string>) => Promise<any>,
  checkForNotifications: () => Promise<any>,
  onOpenModal: (modal: SingleModalState) => any,
  onCloseModal: (modal: SingleModalState) => any,
  onUpdateModal: (modal: SingleModalState) => any,
  projects: Array<Project>,
  clearNotifications: () => any,
  currentUser: User,
  router: Router
};

class Notifications extends Component<Props> {
  render(): React.ReactNode {
    return (
      <NotificationsView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state: State) => ({
  notifications: state.notifications,
  currentUser: state.currentUser,
  projects: state.projects.items,
});

const mapDispatchToProps = dispatch => ({
  getNotifications: (page: number = 1) => dispatch(getNotifications(page)),
  clearNotifications: () => dispatch(clearNotifications()),
  addNotification: (target: string, content: string, sendTo: string|Array<string>) => dispatch(addNotification(target, content, sendTo)),
  checkForNotifications: () => dispatch(checkForNotifications()),
  onOpenModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  onCloseModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
  onUpdateModal: (modal: SingleModalState) => dispatch(updateModal(modal)),
});

const ConnectedNotifications = withRouter(connect(mapStateToProps, mapDispatchToProps)(Notifications as any));

export default ConnectedNotifications;
